import { createFileRoute, redirect } from "@tanstack/react-router";

import { buildLegalPagePath } from "@/lib/legal-page-path";

export const Route = createFileRoute("/_legal/terms/")({
  beforeLoad: ({ context: { locale } }) => {
    throw redirect({ href: buildLegalPagePath(locale, "terms"), statusCode: 301 });
  },
});
